import locationApi from '../services/locationApi'

/* Comptage de POI par zone — servi par location-service.

   Ne renvoie que des nombres. À ne pas confondre avec /location/bbox, qui
   renvoie des POI et les tronque à 500 sans le dire. */

export interface LigneComptage {
  libelle: string
  total: number
  /** Part issue de l'import OpenStreetMap. */
  osm: number
  /** Part collectée par un Spotter Tribe. */
  tribe: number
}

export interface ComptageZone {
  total: number
  /** POI de la zone sans niveau fin — 82 % de la base à ce jour. */
  sansNiveauFin: number
  /** Total des POI relevant des types ciblés, si la quête en fixe. */
  totalCible: number | null
  parCategorie: LigneComptage[]
  parSousType: LigneComptage[]
  genereLe: string
  methode: string
}

export interface LigneEstimation {
  libelle: string
  connu: number
  attendu: number
  ecart: number
}

export interface EstimationZone {
  methode: string
  zoneReference: string
  attendu: LigneEstimation[]
  fiabilite: number
  facteurs: {
    missionsCalibrees: number
    partNiveauFin: number
    zonesReference: number
    formule: string
  }
  avertissement: string
}

export interface ReponseComptage {
  comptage: ComptageZone
  /** INTERNE. Ne jamais recopier dans un document client. */
  estimationInterne: EstimationZone
}

export interface ZoneAComptrer {
  latMin?: number
  latMax?: number
  lngMin?: number
  lngMax?: number
  zonePolygon?: [number, number][]
  typesLieuCibles?: string[]
}

export async function compterZone(zone: ZoneAComptrer): Promise<ReponseComptage> {
  const res = await locationApi.post('/location/comptage', zone)
  return res.data
}
